import { Component, Input, OnInit } from '@angular/core';
import { InvoiceTaxLogDTO } from 'src/app/models/invoice-tax-log.model';
import { SlingConfigService } from 'src/app/services/sling-config.service';

@Component({
  selector: 'app-invoice-tax-logs-table',
  templateUrl: './invoice-tax-logs-table.component.html',
  styleUrls: ['./invoice-tax-logs-table.component.scss']
})
export class InvoiceTaxLogsTableComponent implements OnInit {

  @Input() invoiceTaxLogs: InvoiceTaxLogDTO[] = [];
  @Input() isDialog = false;
  numberOfRows = 10;

  constructor(
    private slingConfigService: SlingConfigService
  ) { }

  ngOnInit(): void {
    if ( !this.isDialog) {
      this.loadSlingConfig();
    }
  }

  loadSlingConfig(): void {
    this.slingConfigService.getSlingConfig().subscribe(
      (data) => {
        const slingConfig = data[0];
        if (slingConfig != null) {
          this.numberOfRows = slingConfig.numberOfRecordsPerPage;
        } else {
          this.numberOfRows = 10;
        }
      },
      (error) => null);
  }

}
